import { render, staticRenderFns } from "./full.vue?vue&type=template&id=63a701a6&scoped=true"
import script from "./full.vue?vue&type=script&setup=true&lang=js"
export * from "./full.vue?vue&type=script&setup=true&lang=js"
import style0 from "./full.vue?vue&type=style&index=0&id=63a701a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a701a6",
  null
  
)

export default component.exports